import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { deletePresetFailed, deletePresetSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* deletePreset(action) {
  try {
    const url = `${BACKEND_URL}/api/v1/violation-preset/${action.payload}`;
    const dataResponse = yield makeRequest(url, {}, action, 'DELETE', true);
    if (dataResponse.status === OK) {
      yield put(deletePresetSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(deletePresetFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(deletePresetFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
